import { jsx as e } from "react/jsx-runtime";
import { MenuLayout as g, MenuType as x } from "./Menu.types.js";
import { MenuProvider as P } from "./MenuProvider.js";
import "react";
import { idsLogger as j } from "../../helpers/utility/idsLogger.js";
import { useIdIfNeeded as k } from "../../hooks/useIdIfNeeded.js";
import { C as A } from "../../floating-ui.react-SmaXvp4L.js";
import { useMenuAria as N } from "./hooks/useMenuAria.js";
import { useMenuComposite as O } from "./hooks/useMenuComposite.js";
import { useMenuStyles as R } from "./hooks/useMenuStyles.js";
import { useMenuRole as b } from "./hooks/useMenuRole.js";
const m = ({
  changeOnBlur: d,
  children: u,
  className: f,
  defaultSelected: a,
  fluid: c,
  id: M,
  layout: r = "stack",
  multiSelect: s,
  noWrap: v,
  onChange: l,
  role: y,
  selected: C,
  type: t,
  ...I
}) => {
  const i = k({ id: M }), p = y ?? t, o = b(s, p), T = N({
    id: i,
    layout: r,
    multiSelect: s,
    role: o
  }), h = R({ className: f, fluid: c, layout: r, role: p }), L = O(o), n = {
    ...I,
    ...h,
    ...T,
    role: o,
    id: i,
    children: u
  };
  return t !== void 0 && j(
    "IressMenu: The type prop is deprecated. Please use the role prop instead."
  ), /* @__PURE__ */ e(
    P,
    {
      changeOnBlur: d,
      defaultSelected: a,
      id: i,
      layout: r,
      multiSelect: s,
      nav: p === "nav",
      noWrap: v,
      onChange: l,
      role: o,
      selected: C,
      children: L ? /* @__PURE__ */ e(A, { loop: o === "menu", render: /* @__PURE__ */ e("div", { ...n }) }) : /* @__PURE__ */ e("div", { ...n })
    }
  );
};
m.Layout = g;
m.Type = x;
export {
  m as IressMenu
};
